// extracted by mini-css-extract-plugin
export default {"hover-link":"ordersRoomService_hover-link__kcYY7"};